import { HeadingLevelContext } from "@/components/heading/HeadingLevelContext";
import { type PropsWithChildren, useContext } from "react";

type HeadingSectionProps = PropsWithChildren & {
  value?: number;
};

export const HeadingSection = ({ children, value }: HeadingSectionProps) => {
  const level = useContext(HeadingLevelContext);

  return (
    <section>
      <HeadingLevelContext value={value || level + 1}>
        {children}
      </HeadingLevelContext>
    </section>
  );
};
